module.exports = __webpack_public_path__ + "static/media/circle-tick-orange.5eb06de8.svg";